export default __webpack_public_path__ + "static/media/flat_label-exaprint1.3f3a1e10.jpg";